import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import DisplayZBericht from "./CashRegisterDemoZBericht";
import { useCookies } from "react-cookie";

const KASSE_ENDPOINT = "https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod";


export default function CashPointClosingList({ clientId }) {
  const [closings, setClosings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const [cookies] = useCookies(["crKey"]);

  useEffect(() => {
    const fetchClosings = async () => {
      try {
        const response = await axios.get(
          `${KASSE_ENDPOINT}/cash_point_closings`,
          { headers: { Authorization: `Bearer ${cookies.crKey} y 1 z` }, params: { client_id: clientId } }
        );
        setClosings(response.data.data || []);
      } catch (error) {
        console.error("Error fetching cash point closings", error);
      } finally {
        setLoading(false);
      }
    };
    fetchClosings();
  }, [clientId]);

  const handleDetail = async (closing) => {
    setDialogOpen(true);
    setDetailLoading(true);
    setDetailData(null);
    try {
      const res = await axios.get(
        `${KASSE_ENDPOINT}/cash_point_closing`,
        { headers: { Authorization: `Bearer ${cookies.crKey} y 1 z` }, params: { client_id: clientId, closing_id: closing.closing_id } }
      );
      setDetailData(res.data.cash_point_closing || res.data);
    } catch (error) {
      console.error("Error loading closing detail", error);
      alert("Fehler beim Laden des Z-Berichts");
      setDialogOpen(false);
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDetailData(null);
  };

  const formatDateTime = (unixSeconds) => {
    if (!unixSeconds) return "";
    return new Date(unixSeconds * 1000).toLocaleString("de-DE", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit"
    });
  };

  return (
    <Box>
      {loading ? (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Schließung #</TableCell>
                <TableCell>Zeit</TableCell>
                <TableCell>Gesamt (€)</TableCell>
                <TableCell>Bargeld (€)</TableCell>
                <TableCell>ErstTrans</TableCell>
                <TableCell>LetztTrans</TableCell>
                <TableCell>Aktion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {closings.map((closing) => (
                <TableRow key={closing.closing_id}>
                  <TableCell>{closing.cash_point_closing_export_id}</TableCell>
                  <TableCell>{formatDateTime(closing.time_creation)}</TableCell>
                  <TableCell>{closing.full_amount.toFixed(2)}</TableCell>
                  <TableCell>{closing.cash_amount.toFixed(2)}</TableCell>
                  <TableCell>{closing.first_transaction_export_id}</TableCell>
                  <TableCell>{closing.last_transaction_export_id}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      disabled={closing.state !== "COMPLETED"}
                      onClick={() => handleDetail(closing)}
                    >
                      Anzeigen
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>Cash Point Closing Detail</DialogTitle>
        <DialogContent dividers>
          {detailLoading ? (
            <Box display="flex" justifyContent="center" p={2}>
              <CircularProgress />
            </Box>
          ) : (
            detailData && <DisplayZBericht data={{ cash_point_closing: detailData }} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
